import Vue from 'vue'
import App from './App.vue'
import vuetify from '@/plugins/vuetify'
import AppRouter from '@/module/router/routes'
import { store } from '@/module/store/store'
// import VConsole from "vconsole";
import $ from 'jquery'
window.$ = window.jQuery = $
Vue.config.productionTip = false

// 測試用獲取token
// setTimeout(async () => {
//   await store().dispatch('auth/LOGIN')
// }, 1)

const app = new Vue({
  router: AppRouter,
  vuetify,
  store: store(),
  components: {},
  render: function (h) { return h(App) }
}).$mount('#app')

export { app }
